const Header = () => {
  return <header className="header pd-x-base">LAKSHYA</header>;
};

export { Header };
